import { nameOfFactory } from "@libs/utils/name-of.utils.ts";

export interface AppointmentSettingsValues {
  apptTypeBaseInterval: string;
  updateUpcomingApptDuration: boolean;
  captureApptCancellationReason: boolean;
  autoLinkCondition: boolean;
}

export const nameOf = nameOfFactory<AppointmentSettingsValues>();
